import React from 'react';

function ListingDetailHeader({ listing, onBack }) {

  return (
    <div className="bg-white shadow-sm">
      <div className="py-4">
        {/* Back button */}
        <button 
          onClick={onBack}
          className="flex items-center text-primary-600 hover:text-primary-800 font-medium"
        >
          <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
          Back to Listings
        </button>
      </div>
      
      <div className="mt-4">
        <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">
          {listing?.title || 'Food Listing'}
        </h1>
        
        {/* Donor info */}
        {listing?.donor && (
          <div className="mt-1 flex items-center text-sm text-gray-500">
            <span>Donated by </span>
            <span className="font-medium text-gray-900 ml-1">
              {listing.donor.name || listing.donor.organization || 'Anonymous Donor'}
            </span>
            {listing.donor.verified && (
              <span className="ml-1">
                <svg className="h-4 w-4 text-primary-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </span>
            )}
          </div>
        )}
        
        {/* Posted date */}
        {listing?.createdAt && (
          <div className="mt-1 text-xs text-gray-500">
            Posted {new Date(listing.createdAt).toLocaleDateString()}
          </div>
        )}
      </div>
    </div>
  );
}

export default ListingDetailHeader;
